export default __webpack_public_path__ + "static/maneti-dashboard-final-b045cca8b81a335b15002f76dd583c11.mp4";